import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllSessions } from "../../core/repo/sessionRepo";
import { getUserDetails } from "../../core/storage/localStorage";
import { makeStyles } from "tss-react/mui";
import Page from "../../components/Page";
import Header from "./Header";
import Filters from "./Filters";
import Results from "./Results/Results";
import Loader from "../../components/Loader";
import useScrollHeader from "../../hooks/useScrollHeader";
import { Box, Typography, Divider } from "@mui/material";
import { useHistory } from "react-router-dom";
import { AI_SEARCH_URL } from "../../utils/routes";
import NoSessions from "./NoSessions";

const useStyles = makeStyles()((theme) => ({
  root: {
    height: "100%",
  },
  gradientText: {
    background: theme.palette.accentGradient,
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
}));

function History() {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { containerRef, showHeader } = useScrollHeader();
  const { sessions, isSessionsLoading } = useSelector((state) => state.session);
  const [filteredSessions, setFilteredSessions] = useState([]);
  const { selectedDomain } = useSelector((state) => state.domain);

  useEffect(() => {
    if (selectedDomain) {
      fetchConversations();
    }
  }, [selectedDomain]);

  useEffect(() => {
    setFilteredSessions(sessions);
  }, [sessions]);

  const fetchConversations = async () => {
    try {
      await dispatch(getAllSessions(selectedDomain.id));
    } catch (err) {
      console.log(err);
    }
  };

  const handleSessionClick = (id) => {
    history.push({
      pathname: `${AI_SEARCH_URL}/${id}`,
      search: "?" + new URLSearchParams({ fromHistory: true }).toString(),
    });
  };

  const handleQueryChange = (query) => {
    let filteredSessions = sessions;
    if (query) {
      filteredSessions = filteredSessions.filter((s) =>
        s["title"].toLowerCase().includes(query.toLowerCase())
      );
    }
    setFilteredSessions(filteredSessions);
  };

  return (
    <Page className={classes.root} title={"History"}>
      <Box
        display={"flex"}
        flexDirection={"column"}
        height={"100%"}
        position={"relative"}>
        <Header showHeader={showHeader} />
        <Divider />
        <Box ref={containerRef} flex={1} overflow={"auto"}>
          <Box
            height="100%"
            maxWidth={900}
            margin={"0 auto"}
            p={{ xs: 2, md: 3 }}
            pb={{ xs: 4, sm: 6 }}>
            {sessions.length === 0 ? (
              <NoSessions />
            ) : (
              <Box>
                <Filters
                  sessions={filteredSessions}
                  handleQueryChange={handleQueryChange}
                />
                <Results
                  sessions={filteredSessions}
                  handleSessionClick={handleSessionClick}
                />
              </Box>
            )}
          </Box>
          {isSessionsLoading && <Loader />}
        </Box>
      </Box>
    </Page>
  );
}

export default History;
